function Home() {
  return (
    <div className="flex flex-col items-center m-6 p-6 justify-center ">
      <h1 className="text-4xl font-bold mb-6">
        Welcome to the Budget Tracking App
      </h1>
      <p className="text-lg text-gray-500">
        Start tracking your expenses and take control of your finances today!
      </p>
    </div>
  );
}

export default Home;
